module.exports = __webpack_public_path__ + "img/legacy-shape-19.e009b6bf.png";